import { gql } from '@apollo/client';

import { BatchMoveResultCode } from '../../types';

/** 执行方式：ASYNC = 异步框架受理（包裹轨迹稍后可见）；SYNC = 同步执行已完成 */
export type MoveExecutionModeApi = 'ASYNC' | 'SYNC';

/** 逐号码执行结果（后端 MoveResultRowType） */
export interface MoveResultRowApi {
    number: string;
    success: boolean;
    resultCode: BatchMoveResultCode | null;
    bagNumber: string | null;
    batchName: string | null;
    needReprint: boolean;
    executionMode: MoveExecutionModeApi | null;
    failedOrderCount: number;
}

/**
 * 移入 / 移出执行后要刷新的页面查询（按操作名，只刷新当前挂着的）：批次列表、批次详情的包牌与操作历史。
 * 批次状态（如「已创建」被推进为「分拣中」）、包牌归属都在后端同步段已改，不刷新会显示过期状态。
 */
export const SORTING_BATCH_MOVE_REFETCH_QUERIES = ['GetSortingBatches', 'GetSortingBatchBags', 'GetSortingBatchOperationLogs'];

const RESULT_ROW_FIELDS = 'number success resultCode bagNumber batchName needReprint executionMode failedOrderCount';

export interface MoveInItemInputApi {
    bagNumber: string;
    targetBatchId: number;
}

export interface MoveIntoSortingBatchData {
    moveIntoSortingBatch: { rows: MoveResultRowApi[] };
}

export const MOVE_INTO_SORTING_BATCH = gql`
    mutation MoveIntoSortingBatch($warehouseId: Long!, $items: [MoveInItemInput!]!) {
        moveIntoSortingBatch(warehouseId: $warehouseId, items: $items) {
            rows { ${RESULT_ROW_FIELDS} }
        }
    }
`;

export interface MoveOutOfSortingBatchData {
    moveOutOfSortingBatch: { rows: MoveResultRowApi[] };
}

export const MOVE_OUT_OF_SORTING_BATCH = gql`
    mutation MoveOutOfSortingBatch($warehouseId: Long!, $numbers: [String!]!) {
        moveOutOfSortingBatch(warehouseId: $warehouseId, numbers: $numbers) {
            rows { ${RESULT_ROW_FIELDS} }
        }
    }
`;
